module.exports = __webpack_public_path__ + "img/2.472eff7b.png";